export class ChatMessageFromClient {
    content: string;
    channelId: number;
}
